import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { Router } from '@angular/router'
import { isValidNumber } from 'libphonenumber-js';
import * as isEmail from 'isemail';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  providers: [AngularFireAuth, AngularFireDatabase],
  animations: [
    trigger('flyInOut', [
      state('in', style({transform: 'translateX(0)'})),
      transition('void => *', [
        style({transform: 'translateX(100%)'}),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({transform: 'translateX(-100%)'}))
      ])
    ])
  ]
})
export class LoginFormComponent implements OnInit {

    confirmationResult : any;
    credentials : any = {};
    loading : boolean = false;
    recaptchaVerifier : any;
    step = 1;
    verified : boolean = false;
    error: boolean = false;
    errorMessage : string;
    passwordReset : boolean = false;

    constructor(public auth : AngularFireAuth, private router : Router, public db: AngularFireDatabase) { }

    ngOnInit() {
    }

    fbLogin() {
      let provider = new firebase.auth.FacebookAuthProvider();
      this.auth.auth.signInWithPopup(provider)
        .then(result => {
          this.router.navigate(['']);
        })
        .catch(error => {
          this.errorMessage = "Un usuario ya existe con ese correo electrónico";
          this.error = true;
        });
    }

    googleLogin() {
      let provider = new firebase.auth.GoogleAuthProvider();

      this.auth.auth.signInWithPopup(provider)
        .then(result => {
          this.router.navigate(['']);
        })
        .catch(error => {
          this.errorMessage = "Un usuario ya existe con ese correo electrónico";
          this.error = true;
        });
    }

    phoneLogin() {
      let controller = this;
      let recaptchaVerifier = new firebase.auth.RecaptchaVerifier('register-button', {
        'size': 'invisible'
      });

      firebase.auth().signInWithPhoneNumber(this.credentials.key, recaptchaVerifier)
        .then(function(confirmationResult) {
          controller.confirmationResult = confirmationResult;
          controller.verified = true;
          controller.loading = false;
          if(controller.step !== 2) controller.next();
        })
        .catch(function(error) {
          this.error = true;
        });
    }

    trySignin() {
      if (!isEmail.validate(this.credentials.key) && !this.credentials.key.startsWith("+"))
        this.credentials.key = "+502"+this.credentials.key;

      if (isValidNumber(this.credentials.key)) {
        this.loading = true;
        this.phoneLogin();
      }
      else {
        this.next();
      }
    }

    signIn() {
      if (this.verified) {
        let code = this.credentials.code;
        let controller = this;
        this.confirmationResult.confirm(code).then(function(result) {
          let credential = firebase.auth.PhoneAuthProvider.credential(controller.confirmationResult.verificationId, code);
          firebase.auth().signInWithCredential(credential);
          controller.router.navigate(['']);
        })
        .catch(error => {
          controller.error = true;
        })
      }
      else {
        firebase.auth().signInWithEmailAndPassword(this.credentials.key, this.credentials.password)
          .then(result => {
            this.router.navigate(['']);
          })
          .catch(error => {
            this.error = true;
          })
      }
    }

    next() {
      this.step = this.step + 1;
    }

    back() {
      this.step = this.step - 1;
    }

    resetPassword() {
      this.passwordReset = true;
    }

}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/login/login-form/login-form.component.ts